<template>
  <div class="row">
    <router-view
      v-bind="{
        dataSelect: this.dataSelect,
        textErreur: this.textErreur,
        textFormulaire: this.textFormulaire
      }"
    />

    <div class="container mt-85">
      <div
        class="wrapper-merci center-align col l12"
        v-for="(dataText, index) in textFormulaire"
        :key="index"
      >
        <h4 class="center-align" v-if="validating === true">
          <span class="fw-400 fs-12 center-align">
            Validation en cours ...
          </span>
        </h4>
        <h4 class="center-align" v-else>
          <span
            class="fw-400 fs-12 center-align"
            v-html="dataText.nCLienErroneTexte"
          ></span>
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import isniForms from "@/data/isniforms.json";
import isniFormsOrga from "@/data/isniformsOrga.json";
import { Constants } from "@/constants";
import { getApiService } from "@/services/getApi.service";
import { helperDataFormService } from "@/services/helperDataForm.service";
import { langService } from "@/services/lang.service";
// mock only
// import isniForms from "@/data/mockFilledIsniForms.json";
// import isniFormsOrga from "@/data/mockFilledIsniFormOrga.json";

export default {
  name: "EmailReceptionPage",
  props: {
    origin: {
      type: String,
      required: true
    },
    langSelected: {
      type: String,
      required: true
    },
    dataSelect: {
      type: Object,
      required: true
    },
    textErreur: {
      type: Object,
      required: true
    },
    textFormulaire: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      langForm: "",
      isniForms,
      isniFormsOrga,
      stepToStart: 1,
      testCaseNotification: null,
      testCaseNotificationParams: {},
      token: null,
      typeDemande: "",
      validating: true
    };
  },
  methods: {
    /**
     * Appel du service pour récupérer les informations des formulaires Isni pré-remplis
     */
    async setIsniForms() {

      /* CASE validationCourriel */
      if (this.origin === "validationCourriel") {
        const resultValidationCourriel = await getApiService.validateTokenFromEmail(
          this.token
        );
        // Check API result
        if (
          resultValidationCourriel.status !== 200 ||
          !resultValidationCourriel ||
          resultValidationCourriel === ""
        ) {
          return false;
        }

        // set information for another methods to use
        this.langForm = resultValidationCourriel.data.langueFormulaire;
        this.stepToStart = 2;
        this.typeDemande = resultValidationCourriel.data.typeDemande;

        /* validationCourriel: perso */
        if (this.typeDemande === Constants.TYPE_FORM.perso) {
          this.isniForms.isniForms.demandeur.email =
            resultValidationCourriel.data.email;
          this.isniForms.isniForms.demandeur.langueFormulaire = this.langForm;
          this.isniForms.isniForms.consentement.admissible = true;
          this.isniForms.isniForms.consentement.information = true;
          this.isniForms.isniForms.consentement.demandeIsni = true;
          this.isniForms.isniForms.jeton = this.token;
          // Set Test Cases Simulation
          if (this.testCaseNotification) {
            this.isniForms.isniForms.testCaseNotification = this.testCaseNotification;
            this.isniForms.isniForms.testCaseNotificationParams = this.testCaseNotificationParams;
          }

          return true;
        }

        /* validationCourriel: orga */
        if (this.typeDemande === Constants.TYPE_FORM.orga) {
          this.isniFormsOrga.isniFormsOrga.demandeur.email =
            resultValidationCourriel.data.email;
          this.isniFormsOrga.isniFormsOrga.demandeur.langueFormulaire = this.langForm;
          this.isniFormsOrga.isniFormsOrga.consentement.admissible = true;
          this.isniFormsOrga.isniFormsOrga.consentement.information = true;
          this.isniFormsOrga.isniFormsOrga.consentement.demandeIsni = true;
          this.isniFormsOrga.isniFormsOrga.jeton = this.token;
          // Set Test Cases Simulation
          if (this.testCaseNotification) {
            this.isniFormsOrga.isniFormsOrga.testCaseNotification = this.testCaseNotification;
            this.isniFormsOrga.isniFormsOrga.testCaseNotificationParams = this.testCaseNotificationParams;
          }

          return true;
        }

        console.debug(
          "[WARN - EmailReceptionPage - setIsniForms] Error : origin = validationCourriel, typeDemande not defined"
        );
        return false;
      }

      /* CASE enrichissement */
      if (this.origin === "enrichissementForm") {
        const isniFormsFromToken = await getApiService.getIsniFormsFromToken(
          this.token
        );

        // Check API result
        if (
          isniFormsFromToken.status !== 200 ||
          !isniFormsFromToken ||
          isniFormsFromToken === ""
        ) {
          return false;
        }

        /* enrichissement: perso */
        if (isniFormsFromToken.data.isniForms) {
          // adjust json form server : missing keys, incorrect positions and names
          const isniFormsPerso = isniFormsFromToken.data.isniForms;
          if (
            !helperDataFormService.preAdjustsJsonFromServer(
              Constants.TYPE_FORM.perso,
              isniFormsPerso
            )
          ) {
            return false;
          }
          // add token
          isniFormsPerso.jeton = this.token;
          // merge with current isniForms stardand
          this.isniForms.isniForms = this.mergeObjects(
            this.isniForms.isniForms,
            isniFormsPerso
          );
          // setup helper fields (check = true, for example)
          helperDataFormService.setupHelperDataForm(
            Constants.TYPE_FORM.perso,
            this.isniForms.isniForms
          );
          // Set Test Cases Simulation
          if (this.testCaseNotification) {
            this.isniForms.isniForms.testCaseNotification = this.testCaseNotification;
            this.isniForms.isniForms.testCaseNotificationParams = this.testCaseNotificationParams;
          }
          // set information for another methods to use
          this.langForm = this.isniForms.isniForms.demandeur.langueFormulaire;
          this.stepToStart = 1;
          this.typeDemande = Constants.TYPE_FORM.perso;

          return true;
        }

        /* enrichissement: orga */
        if (isniFormsFromToken.data.isniFormsOrga) {
          // adjust json form server : missing keys, incorrect positions and names
          const isniFormsOrga = isniFormsFromToken.data.isniFormsOrga;
          if (
            !helperDataFormService.preAdjustsJsonFromServer(
              Constants.TYPE_FORM.orga,
              isniFormsOrga
            )
          ) {
            return false;
          }
          // add token
          isniFormsOrga.jeton = this.token;
          // merge with current isniFormsOrga stardand
          this.isniFormsOrga.isniFormsOrga = this.mergeObjects(
            this.isniFormsOrga.isniFormsOrga,
            isniFormsOrga
          );
          // setup helper fields (check = true, for example)
          helperDataFormService.setupHelperDataForm(
            Constants.TYPE_FORM.orga,
            this.isniFormsOrga.isniFormsOrga
          );
          // Set Test Cases Simulation
          if (this.testCaseNotification) {
            this.isniFormsOrga.isniFormsOrga.testCaseNotification = this.testCaseNotification;
            this.isniFormsOrga.isniFormsOrga.testCaseNotificationParams = this.testCaseNotificationParams;
          }
          // set information for another methods to use
          this.langForm = this.isniFormsOrga.isniFormsOrga.demandeur.langueFormulaire;
          this.stepToStart = 1;
          this.typeDemande = Constants.TYPE_FORM.orga;
          return true;
        }

        console.debug(
          "[WARN - EmailReceptionPage - setIsniForms] Error : origin = enrichissementForm, typeDemande not defined"
        );
        return false;
      }

      return false;
    },
    customReplacementToAssign(objBase, objToCopy, keyRef) {
      // eviter le bug de object null
      if (!objToCopy) {
        console.debug(
          "[WARN - customReplacementToAssign] Exception: objToCopy is empty. (key ref: " +
            keyRef
        );
        objToCopy = objBase;
      }
      const that = this;
      Object.keys(objToCopy).forEach(key => {
        // if array, copy as it
        if (objToCopy[key] instanceof Array) {
          objBase[key] = objToCopy[key];
          return;
        }

        // if has not at the base, copy as it
        if (!(key in objBase)) {
          objBase[key] = objToCopy[key];
          return;
        }

        // if the key is an object, callback to his own loop
        if (typeof objToCopy[key] == "object") {
          that.customReplacementToAssign(objBase[key], objToCopy[key], key);
        }

        // if the key is NOT an object and NOT an array, replace the value
        else {
          objBase[key] = objToCopy[key];
        }
      });
    },
    mergeObjects(objBase, objToCopy) {
      this.customReplacementToAssign(objBase, objToCopy);
      return objBase;
    },
    async setupPage() {
      const isIsniFormsSet = await this.setIsniForms();

      return isIsniFormsSet;
    },
    async taskRunner(fn) {
      const isIsniFormsSet = await fn();

      if (isIsniFormsSet) {
        this.$router.push({
          name:
            this.typeDemande === Constants.TYPE_FORM.perso
              ? "demande-personnel"
              : "demande-organisme",
          params: {
            isniForms:
              this.typeDemande === Constants.TYPE_FORM.perso
                ? this.isniForms
                : {},
            isniFormsOrga:
              this.typeDemande === Constants.TYPE_FORM.orga
                ? this.isniFormsOrga
                : {},
            jumpToStep: this.stepToStart,
            validateEmail: false
          }
        });
      } else {
        this.validating = false;
      }
    },
    updateLangToken() {
      // update lang to all pages
      langService.setLang(this.langSelected);

      // spread the new lang triggers
      this.$emit('emailReceiptPageChangesLangTrigger');
    }
  },
  created() {
    // set token
    this.token = this.$route.params.jeton;
    if (!this.token) {
      this.validating = false;
      return;
    }

    // Prepare Test Cases Simulation
    this.testCaseNotification = this.$route.query["test-case-notification"] || null;
    this.testCaseNotificationParams = this.testCaseNotification ?
        {
          urlIsni: "http://www.isni.org/12345",
          noIsni: "12345",
          urlForm:
              "https://isni-formulaires.banq.qc.ca/enrichissement/" + this.token
        }
        : {};

    // check token and start code
    this.taskRunner(this.setupPage);

    this.updateLangToken();
  }
};
</script>
<style lang="scss">
.main-wrapper {
  .wrapper-consent {
    ul > li {
      list-style-type: initial;
      margin-left: 20px;
    }
    p {
      font-weight: 400;
    }
  }
}
.fs-12 {
  font-size: 30px;
}
</style>
